var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-heading", {
        attrs: {
          "page-title": "Login",
          links: [{ target: "#help-modal", text: "Help" }]
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container", attrs: { id: "content" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "page-alert",
                  { class: { invisible: _vm.isBridgeConnected } },
                  [
                    _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                      _vm._v("Error connecting to the Real-time Interface")
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-9" }, [
              _c(
                "form",
                {
                  staticClass: "form-group",
                  attrs: {
                    id: "login-form",
                    novalidate: "",
                    autocomplete: "off"
                  },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.token,
                            expression: "token"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "observing-token-input",
                          type: "text",
                          required: ""
                        },
                        domProps: { value: _vm.token },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.token = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(_vm._s(_vm.loginFeedback))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-auto" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            id: "begin-session-button",
                            type: "submit",
                            disabled: !_vm.isBridgeConnected
                          }
                        },
                        [
                          _vm._v(
                            "\n                Begin session\n              "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("help-modal", [
            _c("div", { attrs: { slot: "help-text" }, slot: "help-text" }, [
              _c("p", [
                _vm._v(
                  "\n          There may only be one active Real-time Interface (RTI) session at a time for every telescope. Multiple\n          sessions may be active at a time, as long as they are using different telescopes.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          This does not apply to users passively using the RTI up to 5 minutes before or 15 minutes after their\n          sessions.\n        "
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c(
        "label",
        {
          staticClass: "col-form-label",
          attrs: { for: "observing-token-input" }
        },
        [_vm._v("Observing token:")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }